import { put, call } from "redux-saga/effects";
import * as actions from "../actions";
import * as Api from "../../api";

// eslint-disable-next-line import/prefer-default-export
export function* requestBookingData() {
  yield put(actions.bookingsSetIsLoading(true));
  try {
    const response = yield call(Api.getBookings);
    if (response.status === 200) {
      const bookings = response.data;
      if (typeof bookings === "object") {
        yield put(actions.bookingsSetData(bookings));
      } else if (typeof bookings === "string") {
        yield put(actions.addError("bookings", bookings));
      }
    }
  } catch (err) {
    yield put(actions.addError("bookings", err));
  } finally {
    yield put(actions.bookingsSetIsLoading(false));
  }
}
